import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import { io } from "socket.io-client";

import chatbot from "../chatbot";

import {
  AdminAction,
  ProfileAction,
  NotificationsAction,
  ChatbotAction,
  UniversityAction,
  MeetingAction,
  OthersAction,
} from "../../store/actions";

import StudentNavHeader from "./nav-header";
import StudentSidebar from "./sidebar";

import "./dashboard-layout.css";

const socket = io(process.env.REACT_APP_BACKEND_URL, {
  transports: ["websocket"],
  withCredentials: true,
});

const DashboardLayout = ({ children }) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const path = location.pathname;

  const auth = useSelector((state) => state.auth);
  const profileData = useSelector((state) => state.profile?.user);

  const meetings = useSelector((state) => state.meetings);
  const allUniversities = useSelector(
    (state) => state.university.allUniversities
  );

  useEffect(() => {
    if (auth?.user?.user?.id) {
      dispatch(ProfileAction.getUserProfile());
    }
  }, [auth]);

  useEffect(() => {
    socket.current = io(process.env.REACT_APP_BACKEND_URL);
    if (profileData?.id) {
      socket.current.emit("add-user", profileData?.id);
    }
  }, [profileData, path]);

  useEffect(() => {
    dispatch(OthersAction.getCountries());
    dispatch(OthersAction.getRegions());
    dispatch(OthersAction.getContinents());
    dispatch(OthersAction.getVisaInfo());
    dispatch(OthersAction.getProgramTypes());
    dispatch(OthersAction.getTags());
    dispatch(OthersAction.getDiffUniValues());
    dispatch(ChatbotAction.getUsers());
    dispatch(AdminAction.getDashInfo());
    dispatch(AdminAction.getRegPerMonth());
  }, [profileData]);

  useEffect(() => {
    if (allUniversities?.length === 0) {
      dispatch(UniversityAction.getAllUniversities());
    }
  }, []);

  useEffect(() => {
    const meetingPayload = {
      limit: 10,
      offset: 0,
    };
    dispatch(MeetingAction.getUpcomingMeetings(meetingPayload));
    dispatch(MeetingAction.getMeetingRequests(meetingPayload));
    dispatch(MeetingAction.getMeetingInvites(meetingPayload));
    dispatch(MeetingAction.getAllMeetingsAndCount());
  }, [meetings, profileData]);

  useEffect(() => {
    dispatch(
      NotificationsAction.getNotifications({
        userId: profileData?.id,
      })
    );
  }, [path, profileData]);

  return (
    <div className="dashboard-layout">
      <StudentSidebar />
      <div className="content-container">
        <StudentNavHeader />
        <div className="content">
          <Outlet />
          {children}
        </div>
        {!path.includes("/chatbot") && (
          <div className="absolute bottom-[1.25em] right-3 z-[100]">
            <chatbot.ChatbotPopup />
          </div>
        )}
      </div>
    </div>
  );
};
export default DashboardLayout;
